export default "__VITE_ASSET__BzNi20az__"